import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  actions: {
    flexBasis: theme.spacing(33),
    flexGrow: 0,
    flexShrink: 0,
    overflow: 'visible',
    paddingLeft: theme.spacing(1)
  },
  root: {
    backgroundColor: theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: '1px',
    position: 'sticky',
    bottom: 0,
    zIndex: 1
  },
  counts: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    alignItems: 'left',
    justifyContent: 'flexEnd'
  },
  countRoot: {
    margin: theme.spacing(0, 3),
    display: 'block',
    textAlign: 'left',
    fontSize: theme.typography.caption.fontSize
  },
  count: {
    fontSize: theme.typography.caption.fontSize,
    width: 60,
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(-1)
  },
  requested: {
    marginRight: theme.spacing(3)
  },
  itemContainer: {
    borderRight: 'none',
    backgroundColor: 'none'
  },
  timeContainer: {
    background: 'none',
    backgroundColor: 'none'
  },
  totalContainer: {
    background: 'none',
    backgroundColor: 'none'
  },
  container: {
    background: 'none',
    backgroundColor: 'none',
    borderRight: 'none'
  }
}));
